import parse from 'html-react-parser'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Modal } from 'bootstrap'
// import _ from 'lodash'
import BaseTable from '../BaseTable/BaseTable'
import LoadingBtn from '../../buttons/LoadingBtn/LoadingBtn'
import UserCounterPopover from '../../modals/UserCounterPopover/UserCounterPopover'
import Results from '../../components/Results/Results'
import WpStatePicker from '../../pickers/WpStatePicker/WpStatePicker'
import { sendMessages, getConfirmationStatusHistory, getConfirmationPatientResponse } from '../../../actions/confirmation'
import { wpStatus, wpStatus6Month } from '../../../constants/wpStatus'
import { jsonToCsv } from '../../../helpers/excel_json.helper'
import { formatDate, formatTimeToMilitary } from '../../../helpers/style_string.helper'
import { countResponsesStatus, countResponseStatus, formatRowStatus, formatStatusValue } from '../../../helpers/table.helper'
import SendConfirmationModal from '../../modals/SendConfirmationModal/SendConfirmationModal'
import { campaigns } from '../../../constants/campaigns'
import './CampaignTable.css'

function CampaignTable ({
  json,
  header,
  tableState,
  flowStates,
  isHistory,
  campaignState,
  campaignState2,
  fileName,
  onWpStateChange = () => {},
  savingMessagesStatus,
  setSavingMessagesStatus,
  updateLocalStorage,
  setTableState,
  setFlowStates,
  filter,
  resetFilters
}) {
  const location = useLocation()
  const user = useSelector((state) => state.user)
  const table = useSelector((state) => state.table)
  const client = useSelector((state) => state.client)
  const token = useSelector((state) => state.token)

  const [savingMessages, setSavingMessages] = useState(false)
  const [modalState, setModalState] = useState(null)
  const modal = useRef()
  const [tableTitle, setTableTitle] = useState('Plantilla')
  const [counterUsers, setCounterUsers] = useState([])
  const [searchText, setSearchText] = useState('')

  // Acciones modals
  const historyModalRef = useRef()
  const messageModalRef = useRef()
  const [historyModalState, setHistoryModalState] = useState(null)
  const [messageModalState, setMessageModalState] = useState(null)
  const [selectedConfirmation, setSelectedConfirmation] = useState(null)
  const [loadingAction, setLoadingAction] = useState(false)

  useEffect(() => {
    setModalState(new Modal(modal.current))
    setHistoryModalState(new Modal(historyModalRef.current))
    setMessageModalState(new Modal(messageModalRef.current))
  }, [])

  useEffect(() => {
    formatCampaignName(campaignState, campaignState2)
  }, [json])

  useEffect(() => {
    if (table) {
      const confirmations = table?.confirmations?.filter(c => counterUsers.some(u => u._id === c._id))
      const campaign = campaignState !== '' ? campaignState : campaignState2
      countResponseStatus(confirmations, campaign, client._id, setFlowStates)
    }
  }, [counterUsers, table])

  function formatJsonForDB (formattedJson) {
    if (formattedJson.length > 0) {
      // Add safety checks for required IDs
      if (!user?._id || !client?._id) {
        console.warn('User ID or Client ID is undefined, cannot format JSON for DB')
        return null
      }

      const formattedTimeJson = formattedJson.map(row => {
        const { date, time } = row
        const [d, m, y] = date.split('/')
        const formattedDate = y + '-' + m + '-' + d + 'T05:00:00Z'
        const r = {
          ...row,
          time: formatTimeToMilitary(time),
          date: new Date(formattedDate),
          wpStatus: '',
          status: 'STORED'
        }
        if (!row?.name) r.name = r.firstName + ' ' + r.lastName
        if (row.contact) r.contact = row.contact !== 'No'
        return r
      })

      const docName = fileName.replace('.csv', '') + ' - ' + formatDate(new Date())

      return {
        docName,
        confirmations: formattedTimeJson,
        status: 'STORED',
        campaign: campaignState,
        userId: user._id,
        clientId: client._id
      }
    }
  }

  async function sendMessagesToAPI () {
    try {
      const jsonForDB = formatJsonForDB(json)

      // Check if jsonForDB was successfully created
      if (!jsonForDB) {
        toast.error('No se pudo procesar la información. Verifica que todos los datos estén completos.')
        return
      }

      console.log({ table: jsonForDB, client })
      const payload = { table: jsonForDB, client }
      const res = await sendMessages(user, token, payload)
      const data = res.data
      if (data) {
        toast.success('Tus mensajes fueron enviados correctamente.')
        setSavingMessagesStatus('success')
        updateLocalStorage(data, 'table', 'NEW_TABLE')
        setTableState(data)
        // Count the confirmation states
        countResponsesStatus(data, setFlowStates)
      }
    } catch (error) {
      if (error?.response?.status === 400) toast.error(error.response.data.error || error.response.data.message)
      toast.error('Ocurrió un error al enviar tus mensajes. Revisa el archivo y vuelve a intentarlo. ' + error.message)
      setSavingMessagesStatus('error')
    }
    setSavingMessages(false)
  }

  async function startFlow () {
    if (campaignState === '') {
      return toast.error('Selecciona una campaña.')
    }
    setSavingMessages(true)
    await sendMessagesToAPI()
    modalState.hide()
  }

  function downloadCSV (json, header) {
    const { confirmations } = tableState
    const campaign = campaignState !== '' ? campaignState : campaignState2

    // Add safety check for client._id
    if (!client?._id) {
      console.warn('Client ID is undefined, cannot format CSV')
      return
    }

    const formattedJson = json.map((row, i) => {
      let { status } = row
      if (row.status.includes('<select')) {
        status = formatRowStatus(confirmations[i].status, campaign, client._id)
      }
      return { ...row, status }
    })
    const b = jsonToCsv(formattedJson, header)
    // Create a blob
    // eslint-disable-next-line no-undef
    const blob = new Blob([b], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)

    // Create a link to download it
    const pom = document.createElement('a')
    pom.href = url
    pom.setAttribute('download', fileName.replace('.csv', ''))
    pom.click()
  }

  function formatRowData (rowData, row, i) {
    if (
      location.pathname === '/main' &&
      rowData !== null &&
      rowData !== undefined &&
      typeof rowData === 'string') {
      if (rowData.includes('<select') && table) {
        return parse(rowData, {
          replace: ({ attribs }) => {
            if (attribs && attribs.name === 'wp-status') {
              const rowId = attribs.id
              const foundRow = table?.confirmations?.find(c => rowId === c?._id)
              if (!foundRow) return
              const statusArr = foundRow?.status
              return (
                <WpStatePicker
                  wpStatus={table.campaign === '6 month' ? wpStatus6Month : wpStatus}
                  value={statusArr[statusArr.length - 1]}
                  onChange={async (e) => await onWpStateChange(e, foundRow._id)}
                  campaign={table.campaign}
                />
              )
            }
          }
        })
      }
    }
    return rowData
  }

  function countJsonUsers () {
    let jsonLength = 0
    const obj = counterUsers.length > 0 ? counterUsers : json
    obj.forEach((row, i) => {
      const campaign = campaignState !== '' ? campaignState : campaignState2
      const name = campaign === 'marketing' && Object.keys(row).includes('firstName') ? row?.firstName : row?.name
      const nameArr = name?.split(', ')
      jsonLength += nameArr?.length
    })
    return {
      messages: json.length,
      users: jsonLength
    }
  }

  function formatCampaignName (campaignState, campaignState2) {
    const campaign = isHistory.current ? campaignState2 : campaignState

    // Add safety checks to prevent the error
    if (!client?._id || !campaigns[client._id] || !campaign) {
      setTableTitle('Plantilla')
      return
    }

    const clientCampaigns = campaigns[client._id]
    const foundCampaign = clientCampaigns.find(c => c.value === campaign)

    if (foundCampaign && foundCampaign.text) {
      const campaignName = foundCampaign.text.split(' ')[0]
      setTableTitle(campaignName)
    } else {
      setTableTitle('Plantilla')
    }
  }

  function getStatusColor (statusCode) {
    if (!statusCode) return { color: '#555', bg: '#f0f0f0' }
    const c = statusCode.toUpperCase()
    if (c.includes('REPLIED_YES')) return { color: 'rgb(34,165,34)', bg: 'rgba(34,165,34,0.1)' }
    if (c.includes('REPLIED_NO')) return { color: 'rgba(255,0,0,0.803)', bg: 'rgba(255,0,0,0.08)' }
    if (c.includes('REPLIED_CALL')) return { color: 'rgb(0,130,181)', bg: 'rgba(0,130,181,0.1)' }
    if (c.includes('REPLIED_OTHER')) return { color: '#5D3891', bg: 'rgba(93,56,145,0.1)' }
    if (c.includes('NOT_ATTENDED')) return { color: '#f917b1', bg: 'rgba(249,23,177,0.1)' }
    if (c.includes('RESCHEDULED')) return { color: '#175dce', bg: 'rgba(23,93,206,0.1)' }
    if (c.includes('NO_ANSWER')) return { color: '#f94f17', bg: 'rgba(249,79,23,0.1)' }
    if (c.includes('PATIENT_WILL_CALL')) return { color: '#ff55e8', bg: 'rgba(255,85,232,0.1)' }
    if (c.includes('NO_REPLY')) return { color: '#F99417', bg: 'rgba(249,148,23,0.1)' }
    return { color: '#555', bg: '#f0f0f0' }
  }

  async function openHistoryModal (row) {
    if (!row?._id) return
    setSelectedConfirmation({ name: row.name || '' })
    setLoadingAction(true)
    historyModalState?.show()
    try {
      const res = await getConfirmationStatusHistory(user, token, row._id)
      setSelectedConfirmation(prev => ({ ...prev, ...res.data }))
    } catch (error) {
      toast.error('No se pudo cargar el historial de estados.')
    } finally {
      setLoadingAction(false)
    }
  }

  async function openMessageModal (row) {
    if (!row?._id) return
    setSelectedConfirmation({ name: row.name || '' })
    setLoadingAction(true)
    messageModalState?.show()
    try {
      const res = await getConfirmationPatientResponse(user, token, row._id)
      setSelectedConfirmation(prev => ({ ...prev, ...res.data }))
    } catch (error) {
      toast.error('No se pudo cargar el mensaje del paciente.')
    } finally {
      setLoadingAction(false)
    }
  }

  function renderRowActions (row) {
    if (!row?._id) return null
    return (
      <div className='row-actions'>
        {(user?.role === 'ADMIN' || user?.role === 'SUPERUSER') && (
          <span className='action-tooltip-wrapper' data-tooltip='Historial de estados'>
            <button
              className='btn main-btn dr-btn action-btn'
              onClick={(e) => { e.stopPropagation(); openHistoryModal(row) }}
            >
              <i className='fas fa-history' />
            </button>
          </span>
        )}
        <span className='action-tooltip-wrapper' data-tooltip='Último mensaje'>
          <button
            className='btn main-btn dr-btn action-btn'
            onClick={(e) => { e.stopPropagation(); openMessageModal(row) }}
          >
            <i className='fas fa-comment-alt' />
          </button>
        </span>
      </div>
    )
  }

  return (
    <>
      <SendConfirmationModal
        modal={modal}
        modalState={modalState}
        loading={savingMessages}
        campaignState={campaignState}
        startFlow={startFlow}
        jsonLength={countJsonUsers().users}
      />
      <div className='row d-flex title-row'>
        {window.outerWidth > 1028 &&
          <div className='col-md-3'>
            <h1 className='information-title'>
              {tableTitle}
            </h1>
          </div>}
        <div className='col-md-9 title-btns-container'>
          <div className='title-btns'>
            <div className='form-floating input-div'>
              <input
                name='searchText'
                type='name'
                className='form-control search-input'
                id='searchText'
                placeholder='Búsqueda'
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
              <label className='search-label' htmlFor='searchText'>Búsqueda</label>
            </div>
            <div className='container-quantity-filter'>
              <div className='quantity-filter title-btn'>
                <UserCounterPopover
                  message='Usuarios'
                  innerContent={
                    <p>
                      <i className='fas fa-user' />
                      {countJsonUsers().users}
                    </p>
                }
                />
              </div>
            </div>
            {campaignState !== 'marketing' && campaignState2 !== 'marketing' && (
              <button
                onClick={resetFilters}
                className='btn title-btn'
              >
                <i className='fas fa-trash-alt' />
              </button>
            )}
          </div>
        </div>
      </div>
      <BaseTable
        json={json}
        header={header}
        formatRowData={formatRowData}
        filter={filter}
        confirmations={table?.confirmations}
        setCounterUsers={setCounterUsers}
        searchText={searchText}
        setSearchText={setSearchText}
        showFilters
        actions={table ? renderRowActions : null}
      />
      {/* Status History Modal */}
      <div className='modal fade actions-modal' ref={historyModalRef} role='dialog' tabIndex='-1'>
        <div className='modal-dialog modal-dialog-centered modal-dialog-scrollable'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>
                <i className='fas fa-history me-2' />
                Historial de estados
                {selectedConfirmation?.name && (
                  <span className='modal-title-name'> — {selectedConfirmation.name}</span>
                )}
              </h5>
              <button
                type='button'
                className='btn-close'
                onClick={() => historyModalState?.hide()}
              />
            </div>
            <div className='modal-body'>
              {loadingAction
                ? <p className='no-data-msg'><i className='fas fa-spinner fa-spin me-2' />Cargando...</p>
                : !selectedConfirmation?.history || selectedConfirmation.history.length === 0
                    ? <p className='no-data-msg'>No hay historial disponible.</p>
                    : (() => {
                        const finalEntry = selectedConfirmation.history[selectedConfirmation.history.length - 1]
                        const { color, bg } = getStatusColor(finalEntry.status)
                        return (
                          <>
                            <div className='status-badge-container'>
                              <span className='status-label'>Estado actual:</span>
                              <span
                                className='status-current-badge'
                                style={{ color, backgroundColor: bg, borderColor: color }}
                              >
                                {formatStatusValue(finalEntry.status) || finalEntry.status}
                              </span>
                            </div>
                            <table className='table table-striped actions-modal-table'>
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>Estado</th>
                                  <th>Responsable</th>
                                </tr>
                              </thead>
                              <tbody>
                                {selectedConfirmation.history.map((entry, idx) => {
                                  const { color: c } = getStatusColor(entry.status)
                                  return (
                                    <tr key={idx}>
                                      <td>{idx + 1}</td>
                                      <td style={{ color: c, fontWeight: 500 }}>
                                        {formatStatusValue(entry.status) || entry.status}
                                      </td>
                                      <td>{entry.responsible}</td>
                                    </tr>
                                  )
                                })}
                              </tbody>
                            </table>
                          </>
                        )
                      })()}
            </div>
          </div>
        </div>
      </div>

      {/* Last Patient Message Modal */}
      <div className='modal fade actions-modal' ref={messageModalRef} role='dialog' tabIndex='-1'>
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>
                <i className='fas fa-comment-alt me-2' />
                Último mensaje del paciente
                {selectedConfirmation?.name && (
                  <span className='modal-title-name'> — {selectedConfirmation.name}</span>
                )}
              </h5>
              <button
                type='button'
                className='btn-close'
                onClick={() => messageModalState?.hide()}
              />
            </div>
            <div className='modal-body'>
              {loadingAction
                ? <p className='no-data-msg'><i className='fas fa-spinner fa-spin me-2' />Cargando...</p>
                : selectedConfirmation?.rawUserResponse
                  ? (
                    <div className='patient-message-bubble'>
                      <p>{selectedConfirmation.rawUserResponse}</p>
                    </div>
                    )
                  : (
                    <p className='no-data-msg'>
                      <i className='fas fa-inbox me-2' />
                      Sin respuesta del paciente.
                    </p>
                    )}
            </div>
          </div>
        </div>
      </div>

      {(isHistory.current || (tableState && savingMessagesStatus === 'success'))
        ? (
          <Results
            flowStates={flowStates}
            downloadCSV={downloadCSV}
            json={json}
            header={header}
            table={tableState}
          />
          )
        : (
          <div>
            {savingMessagesStatus === 'success' &&
              <p className='success-msg'>¡Los mensajes se enviaron correctamente!</p>}
            {savingMessagesStatus === 'error' &&
              <p className='error-msg'>Ocurrió un error al enviar tus mensajes. Revisa el archivo y vuelve a
                intentarlo.
              </p>}

            {!savingMessages
              ? (
                <button
                  disabled={savingMessages === true}
                  className='main-btn send-btn'
                  onClick={() => modalState.show()}
                >
                  <div className='row main-btn-content'>
                    <div className='col-2'><i className='fas fa-comment-dots' /></div>
                    <div className='col-10'>Enviar</div>
                  </div>
                </button>
                )
              : (<LoadingBtn isLoading={savingMessages} text='Enviando...' className='send-btn' />)}
          </div>)}
    </>
  )
}

export default CampaignTable
